import './inscriptions_forms';
import './inscriptions_forms-list';
import './inscriptions_forms-edit';
import './inscriptions_forms-show_inscriptions';
import './inscriptionsTemplatesModal';